var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import useBreakpoint from "../../../hooks/useBreakpoint";
import { useDispatch, useSelector } from "react-redux";
import { selectEventId, selectCurrentEpisode, selectEpisodes, selectUser, displayModal, selectAppContent, selectAppLanguages, selectHasNotifications, selectMobileDrawerOpen, setMobileDrawerOpen } from "@adm-media/adam-store-plugin";
import Button from "../Buttons/Button";
import { LogoutButton } from "../Buttons/LogoutButton/LogoutButton";
import { useSetCurrentEpisode } from "../../../hooks/useSetCurrentEpisode";
import { EVALUATION_MODAL, QUIZ_MODAL } from "../../modals";
import { isEmpty } from "../../../utils/obj-check";
import { Space } from "antd";
import SelectLang from "../Select/SelectLang/SelectLang";
import { HamburgerIcon } from "../Icons/Icons";
import { useLocation, useNavigate } from "react-router-dom";
import { useIsEvaluationFormAvailable } from "../../../hooks/useIsEvaluationFormAvailable";
import { useShowQuizButton } from "../../../hooks/useShowQuizButton";
import { Notifications } from "../../functional/Notifications/Notifications";
import { Paths } from "../../../pages";
import "./NavbarActions.scss";
import { OpenLoginModalButton } from "../Buttons/OpenLoginModalButton/OpenLoginModalButton";
var NavbarActions = function () {
    var _a;
    var navigate = useNavigate();
    var pathname = useLocation().pathname;
    var dispatch = useDispatch();
    var _b = useBreakpoint(), isMobile = _b.isMobile, isMiniTablet = _b.isMiniTablet, isTablet = _b.isTablet;
    var setCurrentEpisode = useSetCurrentEpisode().setCurrentEpisode;
    var episodes = useSelector(selectEpisodes);
    var _c = useIsEvaluationFormAvailable(), isEvaluationFormAvailable = _c.isEvaluationFormAvailable, isEvaluationFormAlreadyAnswered = _c.isEvaluationFormAlreadyAnswered;
    var _d = useShowQuizButton(), isQuizOpen = _d.isQuizOpen, isQuizAlreadyAnswered = _d.isQuizAlreadyAnswered;
    var contents = useSelector(selectAppContent);
    var languages = useSelector(selectAppLanguages);
    var hasNotifications = useSelector(selectHasNotifications);
    var isWatchRoute = pathname === Paths.watchPlayer;
    var isPageDetailRoute = (_a = pathname === null || pathname === void 0 ? void 0 : pathname.startsWith(Paths.pageDetail)) !== null && _a !== void 0 ? _a : false;
    var eventId = useSelector(selectEventId);
    var _e = useSelector(selectUser), token = _e.token, identity = _e.identity;
    var isMobileDrawerOpen = useSelector(selectMobileDrawerOpen);
    var navbar_custom_buttons_configuration = useSelector(selectCurrentEpisode).navbar_custom_buttons_configuration;
    var showEvaluationModal = function () {
        dispatch(displayModal({ name: EVALUATION_MODAL }));
    };
    var showQuizModal = function () {
        dispatch(displayModal({
            name: QUIZ_MODAL
        }));
    };
    // const showQAModal = () => dispatch(displayModal({ name: QA_MODAL }));
    var authButton = (identity === null || identity === void 0 ? void 0 : identity.id) ? _jsx(LogoutButton, { className: "navbar-logout-button" }, "logout") : _jsx(OpenLoginModalButton, {});
    var evaluation = isEvaluationFormAvailable && (_jsx(Button, __assign({ disabled: isEvaluationFormAlreadyAnswered, "data-testid": "evaluation-form-button", type: "default", className: "evaluation-button", onClick: showEvaluationModal }, { children: contents.evaluation_form_title || "Evaluation form" }), "evaluation"));
    var quiz = isQuizOpen && (_jsx(Button, __assign({ type: "default", "data-testid": "quiz-button", disabled: isQuizAlreadyAnswered, onClick: showQuizModal }, { children: contents.quiz_title || "Quiz" }), "quiz"));
    var backToEpisodes = (episodes === null || episodes === void 0 ? void 0 : episodes.length) > 1 && (_jsx(Button, __assign({ type: "default", "data-testid": "back-to-episodes-button", onClick: function () {
            var previewUrl = new URLSearchParams(window.location.search);
            var myparam = previewUrl.get("preview");
            var preview = myparam ? "".concat(Paths.watch, "?preview=").concat(myparam) : "".concat(Paths.watch);
            navigate(preview);
            setCurrentEpisode({ episodeId: null });
        }, className: "select-episode" }, { children: contents.change_episode }), "backToEpisodes"));
    var attemptEvent = isPageDetailRoute && (identity === null || identity === void 0 ? void 0 : identity.id) && (_jsx(Button, __assign({ type: "default", "data-testid": "attempt-event-button", onClick: function () {
            var previewUrl = new URLSearchParams(window.location.search);
            var myparam = previewUrl.get("preview");
            var preview = myparam ? "".concat(Paths.watch, "?preview=").concat(myparam) : "".concat(Paths.watch);
            navigate(preview);
            setCurrentEpisode({ episodeId: null });
        }, className: "select-episode" }, { children: contents.attempt_event || "Attempt" }), "attemptEventBtn"));
    // const openQAModalButton = (
    //     <Button key="qna-conference-button" data-testid="qna-conference-button" className={"qna-conference-button"} onClick={showQAModal}>
    //         {contents.qna_title}
    //     </Button>
    // );
    var selectLanguages = languages.length > 1 && _jsx(SelectLang, {}, "selectLanguages");
    var notifications = _jsx(Notifications, {}, "notifications");
    var buttonSlots = {
        100: hasNotifications ? [notifications] : [],
        90: isWatchRoute ? [evaluation] : [],
        80: [],
        70: isWatchRoute ? [quiz] : [],
        60: [],
        50: isWatchRoute ? [backToEpisodes] : [],
        // 40: isChannelConference(channel) ? [openQAModalButton] : [],
        40: [],
        30: [attemptEvent, selectLanguages],
        20: [],
        10: [authButton],
        0: []
    };
    var buttonSlotsKeys = Object.keys(buttonSlots);
    if (navbar_custom_buttons_configuration === null || navbar_custom_buttons_configuration === void 0 ? void 0 : navbar_custom_buttons_configuration.length) {
        navbar_custom_buttons_configuration.forEach(function (item, i) {
            var _a;
            if (!item.visible && isEmpty(identity)) {
                return;
            }
            var label = (item === null || item === void 0 ? void 0 : item.label[identity.lang_id]) || (item === null || item === void 0 ? void 0 : item.label["en"]);
            var mapObj = {
                "{EVENT_CODE}": eventId,
                "{USER_TOKEN}": token
            };
            var href = item.href
                ? item.href.replace(/\{EVENT_CODE\}|\{USER_TOKEN\}/gi, function (matched) {
                    return mapObj[matched];
                })
                : undefined;
            var btnElement = (_jsx(Button, __assign({ type: "default", role: "link", href: href, target: item.target, style: item === null || item === void 0 ? void 0 : item.style, className: item.class }, { children: label }), i));
            (_a = buttonSlots[(item === null || item === void 0 ? void 0 : item.position) || 100]) === null || _a === void 0 ? void 0 : _a.push(btnElement);
        });
    }
    var buttons = [];
    buttonSlotsKeys.reverse().forEach(function (k) {
        buttons === null || buttons === void 0 ? void 0 : buttons.push(buttonSlots[k]);
    });
    var closableSidebar = isMobile || isMiniTablet || isTablet;
    return (_jsx("div", __assign({ "data-testid": "navbar-actions" }, { children: !isWatchRoute || !closableSidebar ? (_jsx(Space, { children: buttons })) : (_jsxs("div", __assign({ className: "navbar-actions__hamburger-icon-container" }, { children: [hasNotifications && notifications, selectLanguages, _jsx(HamburgerIcon, { open: isMobileDrawerOpen, onClick: function () { return dispatch(setMobileDrawerOpen(!isMobileDrawerOpen)); } })] }))) })));
};
export default NavbarActions;
